import type React from "react";

import type { BreadcrumbsProps } from "./Breadcrumbs.model";
import { NavLink, NavList } from "./Breadcrumbs.styled";

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ pathnames, textValues }) => {
  if (pathnames.length !== textValues.length) {
    return null;
  }

  return (
    <nav aria-label="breadcrumb">
      <NavList>
        {pathnames.map((value, index) => (
          <NavLink key={`${value}-${index}`} to={value}>
            {textValues[index]}
          </NavLink>
        ))}
      </NavList>
    </nav>
  );
};
